import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { Translation } from "@/components/Translation/Translation.component";
type TrialUpgradeProgressBarProps = {
  readonly remainingDays: number;
  readonly progressPercentage: number;
  readonly variant?: "default" | "ending-soon";
};
export function TrialUpgradeProgressBar(t0) {
  const $ = _c(14);
  const {
    remainingDays,
    progressPercentage,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const isLastDay = remainingDays <= 1;
  let t2;
  if ($[0] !== isLastDay || $[1] !== remainingDays) {
    t2 = <div className="mb-0.5 text-right text-xs"><Translation model={isLastDay ? {
        da: "Sidste dag i din pr\xF8veperiode",
        de: "Letzter Tag Ihrer Testphase",
        en: "Last day of your trial period",
        no: "Siste dag i pr\xF8veperioden din",
        sv: "Sista dagen p\xE5 din provperiod"
      } : {
        da: `${remainingDays} dage tilbage`,
        de: `${remainingDays} Tage verbleibend`,
        en: `${remainingDays} days remaining`,
        no: `${remainingDays} dager igjen`,
        sv: `${remainingDays} dagar kvar`
      }} /></div>;
    $[0] = isLastDay;
    $[1] = remainingDays;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = variant === "ending-soon" ? "bg-silver" : "bg-whisper";
  let t4;
  if ($[3] !== t3) {
    t4 = clsx("mb-0.25 w-full overflow-hidden rounded-full", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${progressPercentage}%`;
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="h-1 rounded-full bg-highlight" style={{
      width: t5
    }} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== progressPercentage || $[8] !== t4 || $[9] !== t6) {
    t7 = <div aria-valuemax={100} aria-valuemin={0} aria-valuenow={progressPercentage} className={t4} role="progressbar">{t6}</div>;
    $[7] = progressPercentage;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <section>{t2}{t7}</section>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}